export default __webpack_public_path__ + "static/mlw-white-917088a0935a7f58d18a3382d7b5a4b9.png";